import { IOrderOut, IWarehouseListOut } from "openapi/types";
import { Text } from "atoms";
import { OrderProductRow } from "./components/OrderProductRow/OrderProductRow";
import { Stack, useTheme } from "@mui/material";

interface IOrderTableProps {
  warehouseList: IWarehouseListOut[];
  order: IOrderOut;
  disabled: boolean;
}

export const OrderProductsTable = ({
  warehouseList,
  order,
  disabled,
}: IOrderTableProps) => {
  const { palette } = useTheme();

  return (
    <div>
      {warehouseList.map((warehouse, index) => (
        <Stack mb={index < warehouseList.length - 1 ? "3rem" : 0}>
          <Text bold fontSize="18px">
            Depozit:{" "}
            <span style={{ color: palette.secondary.dark }}>
              {warehouse.title}
            </span>
          </Text>
          <div style={{ display: "grid" }}>
            {order?.products
              ?.filter(
                (prod) => prod.product?.warehouse === warehouse.warehouseId,
              )
              ?.slice()
              .sort((a, b) => {
                const nameA = a.product?.name ?? "";
                const nameB = b.product?.name ?? "";
                return nameA?.localeCompare(nameB);
              })
              .map((product) => (
                <OrderProductRow
                  orderId={order.orderId}
                  orderProduct={product}
                  disabled={disabled}
                />
              ))}
          </div>
        </Stack>
      ))}
    </div>
  );
};
